export default __webpack_public_path__ + "static/media/instructor-badge.c4620d0e.svg";